import React from 'react';

import { ReactComponent as FaveLogo } from 'assets/img/logo-fave-pink.svg';
import mockupImg from 'assets/img/mobile-mockup.png';
import { animated, useSpring } from 'react-spring';

const MainView = ({
  setXTransition,
  start,
  country,
  isId,
  isPortraitMobile,
}) => {
  const textProps = useSpring({
    config: {
      mass: 20,
      friction: 100,
    },
    opacity: start ? '1' : '0',
    transform: `translate(0, ${start ? '0' : -window.innerHeight + 'px'})`,
  });

  const rewards = {
    my: 'RM3',
    sg: 'S$3',
    id: 'Rp12.000',
  };

  return (
    <main className="main">
      <animated.div style={textProps} className="w-100">
        <div className="text-container">
          <div className="main-container">
            <div className="logo">
              <FaveLogo />
            </div>
            <header>
              <h1 className="subtitle">
                {isId ? 'Akses Awal' : 'Early Access'}
              </h1>
              <h2 className="title">
                {isId ? 'Lebih banyak reward,' : 'More rewards,'}
                <br /> {isId ? 'dengan cara baru.' : 'in all new ways.'}
              </h2>
            </header>
            <p>
              {isId
                ? 'Nikmati pengalaman pembaharuan terbesar yang pernah ada di Fave. Jadilah salah satu pengguna beta kami dan rasakan aplikasi reward dan gaya hidup terkini.'
                : 'Enjoy the biggest experience update ever on Fave. Be one of our beta users and get your hands on the future of our reward and lifestyle app.'}
            </p>
            <section className="button-container">
              <button
                className="button"
                onClick={() =>
                  setXTransition(
                    isPortraitMobile
                      ? 'translateX(-100vw)'
                      : 'translateX(-50vw)'
                  )
                }
              >
                {isId ? 'Dapatkan Akses Awal' : 'Get Early Access'}
              </button>
              <p className="word-break">
                <strong>
                  {isId ? 'Dapatkan' : 'FREE'} {rewards[country]}*
                </strong>{' '}
                {isId
                  ? ' e-Cashback untuk menjadi pengguna beta awal.'
                  : 'e-Cashback for being an early beta user.'}
              </p>
            </section>
            <small className="word-break">
              *{' '}
              {isId
                ? 'e-Cashback akan diberikan setelah menyelesaikan fase beta.'
                : 'e-Cashback will be credited upon completion of beta phase.'}
            </small>
          </div>
          <div className="img-container desktop-hide">
            <img src={mockupImg} alt="Fave on mobile phones" />
          </div>
        </div>
      </animated.div>
    </main>
  );
};

export default MainView;
